import { SvgIcon } from '@progress/kendo-react-common';
import { bellIcon, gearIcon, globeIcon } from '@progress/kendo-svg-icons';
import {
  GetBulkFlowIcon,
  GetEndpointIcon,
  GetEndpointMP2Icon,
  GetGatewayIcon,
  GetGatewayHMEIcon,
  GetGreasePumpGlyphIcon,
  GetHeadUnitIcon,
  GetPointIcon,
} from '../../../../../Utilities/CustomIcons';
import { DeviceType } from '../../../../../Enums/DeviceType';
import { getCriticalityIcon } from '../../../../Shared/Utilities/criticalityIcon';
import type { EntityType } from './EntityNotesPanel';

/**
 * Icon for a note's entity. `Point` (grease tag) uses the point glyph from the Site Explorer tree.
 * For `Endpoint` we refine by `entityMetadata.deviceType` (MP2 / Bulk Flow / plain) to match the device tables.
 * For `Device` we refine by `deviceType` (head unit vs gateway variants). `GreasePump` has a
 * dedicated glyph and `Location` a map marker. `Alert` uses the criticality chevron (from
 * `entityMetadata.criticality`, matching the drawer header, bell fallback) while `AlertNotification`
 * uses a bell; everything else falls back to a gear.
 */
export function getEntityNoteIcon(entityType: EntityType, deviceType?: string, size = 18, criticality?: string) {
  if (entityType === 'Point') return GetPointIcon(size, size);
  if (entityType === 'Endpoint') {
    if (deviceType === DeviceType.EndpointMP2) return GetEndpointMP2Icon(size, size);
    if (deviceType === DeviceType.EndpointBF) return GetBulkFlowIcon(size, size);
    return GetEndpointIcon(size, size);
  }
  if (entityType === 'Device') {
    if (deviceType === DeviceType.HeadUnit) return GetHeadUnitIcon(size, size);
    if (deviceType === DeviceType.Gateway) return GetGatewayIcon(size, size);
    return GetGatewayHMEIcon(size, size);
  }
  if (entityType === 'GreasePump') return GetGreasePumpGlyphIcon(size, size);
  if (entityType === 'Location') return <SvgIcon icon={globeIcon} size="medium" />;
  if (entityType === 'Alert') return getCriticalityIcon(criticality) ?? <SvgIcon icon={bellIcon} size="medium" />;
  if (entityType === 'AlertNotification') return <SvgIcon icon={bellIcon} size="medium" />;
  return <SvgIcon icon={gearIcon} size="medium" />;
}
